import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import Debts from "./pages/Debts";
import DebtDetail from "./pages/DebtDetail";
import Strategy from "./pages/Strategy";
import Assets from "./pages/Assets";
import NetWorthPage from "./pages/NetWorthPage";
import PlanPage from "./pages/PlanPage";
import ActivityPage from "./pages/ActivityPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route
                element={
                  <ProtectedRoute>
                    <Layout />
                  </ProtectedRoute>
                }
              >
                <Route path="/" element={<Dashboard />} />
                <Route path="/debts" element={<Debts />} />
                <Route path="/debts/:id" element={<DebtDetail />} />
                <Route path="/activity" element={<ActivityPage />} />
                <Route path="/payments" element={<ActivityPage />} />
                <Route path="/assets" element={<Assets />} />
                <Route path="/networth" element={<NetWorthPage />} />
                <Route path="/plan" element={<PlanPage />} />
                <Route path="/strategy" element={<Strategy />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster richColors position="bottom-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
